import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';

export interface IGetLDHashData {
  getLDHash: {
    ldHash: string | null;
  };
}

export const GET_LD_HASH: TypedDocumentNode<IGetLDHashData> = gql`
  query getLDHash {
    getLDHash {
      ldHash
    }
  }
`;
